<template>
  <div>
    <zj-layout-container
      v-loading="loading"
      element-loading-text="加载中..."
    >
      <zj-layout-header>
        <div class="listtitle">停车场数据统计</div>
        <el-form
          class="zj-search-form"
          ref="queryForm"
          :model="queryParams"
          :label-width="labelWidth"
        >
          <el-form-item label="时间" prop="timeRange">
              <el-date-picker
                v-model="queryParams.timeRange"
                type="daterange"
                align="right"
                unlink-panels
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                :picker-options="pickerOptions"
                :clearable="false">
              </el-date-picker>
          </el-form-item>
          <el-form-item label class="right">
            <el-button @click="onSearch">查 询</el-button>
            <el-button @click="onCancel">清 理</el-button>
          </el-form-item>
        </el-form>
        <el-divider></el-divider>
      </zj-layout-header>
      <zj-layout-main>
        <div class="ecahrts-wrap">
          <div class="ecahrts-left">
            <div ref="map-onemap" class="map"></div>
          </div>
          <div class="echart-right">
            <div>
              <linechart
                title=""
                xAxisName=""
                yAxisName=""
                :chartData="compareData"
              ></linechart>
            </div>
            <div>
              <div>
                <barchart2
                  title="游客来源（省）"
                  xAxisName=""
                  yAxisName=""
                  className="echarts-01"
                  :chartData="provinceTop10"
                ></barchart2>
              </div>
              <div>
                <barchart2
                  title="游客来源（市）"
                  xAxisName=""
                  yAxisName=""
                  className="echarts-02"
                  :chartData="cityTop10"
                ></barchart2>
              </div>
            </div>
          </div>
        </div>
      </zj-layout-main>
    </zj-layout-container>
  </div>
</template>

<script>
import { getSourceProvinceByTimeValue, getSourceCityByTimeValue, getTrendByTimes, getRealTimeData } from "@/api/src/bigData";

import ZJApp from '../../../../app';
const utils = ZJApp.ZJUtils;

import moment from 'moment';
export default {
  name: "BizVehicle",
  controller: "UI",
  action: "BizVehicle",
  components: {
  },
  data() {
    return {
      // 遮罩层
      loading: false,
      pickerOptions: {
        shortcuts: [{
          text: '最近一周',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近一个月',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近三个月',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
            picker.$emit('pick', [start, end]);
          }
        }]
      },
      queryParams:{
        timeRange:null,
      },
      compareData:{
        days:[],
        data:[],
      },
      legendData:[],
      provinceTop10:{
        days:[],
        data:[],
      },
      cityTop10:{
        days:[],
        data:[],
      },
      ageData:{
        days:[],
        data:[],
      },
      sexData:[
        {name:'男',value:0},
        {name:'女',value:0}
      ],
      proveiceData:[],
    };
  },
  created: function() {
    this.$nextTick(()=>{
      this.onCancel()
    });
  },
  mounted(){
   // 创建地图，并通过样式让地图填满窗口
    let that = this;

    this.$nextTick(function() {
      // 不传入 syscode 和 key ，或者值为空时，
      // zjumap 插件自动从 URL 地址
      // http://HOST:PORT/Areas/Map/Content/UMap.html?syscode=xxx&key=yyy
      // 中读取 syscode 和 key 的值。
      // eslint-disable-next-line no-undef
      $(that.$refs["map-onemap"]).zjumap({
        syscode: "ZJMap",
        key: "parkMap",
        loading: ".global-loading",
        loadingText: ".global-loading-text",
        //地图配置
        mapConfigs: {
          //mapStyle: "styles/darknight.json",
          toggleTool: "tool/TreeToggleX",
          //tilesPath: "",
          //clickToShowLocation: false,
          //zoom:16,
          onMapCreated: function(e) {
            that.mapInstance = e.map;
            that.center = e.map.config.center;

            //that.addDom();
          },
          onGettingLayerData: function(e) {
            // eslint-disable-next-line no-undef
            e.opts.ServiceData = $.extend({}, e.opts.ServiceData, {
              Longitude: that.center[0],
              Latitude: that.center[1]
            });
          },
          //地图开关面板切换事件，切换右侧列表框的tab项
          onToogleSwitchClick: function(e) {
            that.broadcast(
              "componentPOISearchResult",
              "onMapToogleSwitchClick",
              e.type
            );
          },
          onLayerDetaiButtonClick: function(e) {
            console.log(e.data);
            var item = e.originEvent.currentTarget;
            // eslint-disable-next-line no-undef
            var id = e.data.id;
            // eslint-disable-next-line no-undef
            var category = $(item).data("category");
            var result = {
              id: id,
              type: "search",
              category: category
            };
            that.showRecordDetail(result);
          }
        }
        //,gotMapConfigs: function (conf, opts) { } //当从统一配置中获取到地图配置，并合并完 mapConfigs 后，触发此事件。
      });
    });
  },
  methods: {
   // 点击清理按钮
    onCancel() {
      this.queryParams.timeRange = [moment().format('YYYY-MM-DD'),moment().format('YYYY-MM-DD')]
      this.onSearch();
    },
    async onSearch(){
      this.loading = true
      this.init()
      let { queryParams:{timeRange:[startTime, endTime]}, provinceTop10, cityTop10, compareData } = this, that = this;
      var params = this.getAreaTimeSearchParams(this.config.area.type, this.config.area.code, startTime, endTime);

      this.init()
      utils.waitAll([
        getSourceProvinceByTimeValue("staCarAnalysis", params), 
        getSourceCityByTimeValue("staCarAnalysis", params), 
        getTrendByTimes("staCarAnalysis", params),
      ])
      .then(res => {
        that.loading = false;
        
        that.proveiceData = res[0].data || []
        
        res[0].data&&res[0].data.forEach((item, index) => {
          if(index < 10){
            provinceTop10.days.push(item.name)
            provinceTop10.data.push(item.count)
          }
        })
        res[1].data&&res[1].data.forEach((item, index) => {
          if(index < 10){
            cityTop10.days.push(item.name)
            cityTop10.data.push(item.count)
          }
        })
       this.provinceTop10 = provinceTop10
       this.cityTop10 = cityTop10

        // let days = [],data = []
        res[2].data&&res[2].data.map(item =>{
          compareData.days.push( moment(item.time ).format('HH:00') )
          compareData.data.push( item.countIn )
        })
        this.compareData = compareData

      }).catch((res =>{
        this.loading = false;
      }))
    },
    init(){
      this.compareData={
        days:[],
        data:[],
      }
      this.provinceTop10 = {
        days:[],
        data:[],
      }
      this.cityTop10 = {
        days:[],
        data:[],
      }
    }
  },
};
</script>
<style scoped lang="scss">
.ecahrts-wrap {
  position: relative;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-bottom:2.8rem;
}
.ecahrts-left{
  width: 50%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  div{
    width: 100%;
    height: 100%;
  }
}
.echart-right {
  width: 50%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  >div{
    width: 100%;
    height: 48%;
    display: flex;
    align-items: center;
    div{
      width: 50%;
      height: 100%;
    }
  }
}
</style>
